import { Component, Input } from '@angular/core';

@Component({
    selector: 'bizz-view-stack-skeleton-element',
    imports: [],
    templateUrl: './view-stack-skeleton-element.component.html',
    styleUrl: './view-stack-skeleton-element.component.scss'
})
export class ViewStackSkeletonElementComponent {

  @Input() public bgClass: string = 'bg-section';
  @Input() public borderClass: string = 'border-transparent';
  @Input() public customHeightClass = 'h-9';
}
